import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Modal, Button } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";

const SuccessModal = (props) => {
  const { isSuccessShow, setIsSuccessShow, onClose } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setIsSuccessShow(false)
    onClose()
  }

  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={isSuccessShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>SUCCESS!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2" style={{ backgroundColor: '#e0f9e0' }}>
                  {/* <p><strong>Proceed?!</strong></p> */}
                  <p className="mb-0"><strong>SUCCESS! </strong>Data succesfully processed , Pending next steps!</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>

          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default SuccessModal